import { Editor, Transforms } from 'slate';
import { ImageElement } from '../types';

export const insertImage = (editor: Editor, src: string) => {
	const text = { text: '' };
	const image: ImageElement = { type: 'image', src, children: [text] };
	Transforms.insertNodes(editor, image);
};
